<template>
	<div id="app" @click="hideSelects" @scroll="hideSelects">
		<Spinner></Spinner>
		<router-view name="header"></router-view>
		<router-view></router-view>
		<router-view name="footer"></router-view>
	</div>
</template>

<script>
import Spinner from "./components/Spinner.vue";

export default {
	components: {
		Spinner: Spinner
	},
	created() {
		window.addEventListener("scroll", this.hideSelects);
	},
	methods: {
		hideSelects(event) {
			if (event.target.id != "search-channel-input" && document.getElementById("select-channels")) {
				document.getElementById("select-channels").style.display = "none";
			}
			if (event.target.id != "search-product-input" && document.getElementById("select-products")) {
				document.getElementById("select-products").style.display = "none";
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/App.vue